import type { components } from '../types/generated';

type PublicAddonDto = components['schemas']['PublicAddonDto'];
type PublicAddonAttachmentDto =
  components['schemas']['PublicAddonAttachmentDto'];

export type AddonType = NonNullable<PublicAddonDto['type']>;
export type AddonStatus = NonNullable<PublicAddonDto['status']>;
export type AddonAttachmentType = NonNullable<
  PublicAddonAttachmentDto['attachmentType']
>;

export interface MappedAddonAttachment {
  id: string;
  displayName: string;
  contentType?: string;
  attachmentType?: AddonAttachmentType;
  attachmentTypeDisplayName?: string;
  formattedFileSize?: string;
  /** Presigned URL inline — do podglądu (iframe/img/video). */
  previewUrl?: string;
  /** Presigned URL wymuszający pobranie (Content-Disposition: attachment) — pod przycisk pobierania. */
  downloadUrl?: string;
}

export interface MappedAddon {
  id: string;
  type: AddonType;
  typeDisplayName: string;
  status: AddonStatus;
  metadata?: string;
  fulfilledAt?: string;
  attachments: MappedAddonAttachment[];
}

const mapAttachment = (
  attachment: PublicAddonAttachmentDto,
): MappedAddonAttachment => ({
  id: attachment.id ?? '',
  displayName: attachment.displayName ?? '',
  contentType: attachment.contentType,
  attachmentType: attachment.attachmentType,
  attachmentTypeDisplayName: attachment.attachmentTypeDisplayName,
  formattedFileSize: attachment.formattedFileSize,
  previewUrl: attachment.presignedUrl,
  downloadUrl: attachment.downloadUrl ?? attachment.presignedUrl,
});

export const mapAddonsToUI = (
  addons: PublicAddonDto[] | null | undefined,
): MappedAddon[] => {
  if (!addons?.length) return [];

  return addons
    .filter((addon) => addon.id && addon.type && addon.status)
    .map((addon) => ({
      id: addon.id!,
      type: addon.type!,
      typeDisplayName: addon.typeDisplayName ?? '',
      status: addon.status!,
      metadata: addon.metadata,
      fulfilledAt: addon.fulfilledAt,
      attachments: (addon.attachments ?? [])
        .filter((a) => a.id)
        .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        .map(mapAttachment),
    }));
};
